import { render, staticRenderFns } from "./PasswordLogin.vue?vue&type=template&id=422b9185&scoped=true&"
import script from "./PasswordLogin.vue?vue&type=script&lang=js&"
export * from "./PasswordLogin.vue?vue&type=script&lang=js&"
import style0 from "./PasswordLogin.vue?vue&type=style&index=0&id=422b9185&prod&lang=css&"
import style1 from "./PasswordLogin.vue?vue&type=style&index=1&id=422b9185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b9185",
  null
  
)

export default component.exports